import { login, refreshToken, impersonateByRefreshToken } from './tokenAuth';
import { changePassword, resetPassword, getSecurityQuestions, submitAnswer } from './authApi';
import { setAuthData, setAuthDataFromUrl, getAuthData, autoLogin } from '../auth/session';

const Auth = {
  autoLogin,
  submitAnswer,
  getSecurityQuestions,
  getAuthData,
  setAuthDataFromUrl,
  refreshToken,
  impersonateByRefreshToken,
  login,
  changePassword,
  resetPassword,
  setAuthData,
};

export default Auth;
export {
  autoLogin,
  submitAnswer,
  getSecurityQuestions,
  getAuthData,
  setAuthDataFromUrl,
  refreshToken,
  impersonateByRefreshToken,
  login,
  changePassword,
  resetPassword,
  setAuthData,
};